import { Injectable, Inject, Optional } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlSegment,
  Router,
} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { TokenService } from './token.service';
import { ConfigService } from '@core/bootstrap/config.service';

//const LOGIN_URL = '/admin/login';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  LOGIN_URL: string;
  constructor(
    private router: Router,
    private token: TokenService,
    private config: ConfigService,
    @Optional() @Inject(DOCUMENT) private document: any
  ) {
    var conf = this.config.getConfig();
    this.LOGIN_URL = conf.loginurl;
  }

  private gotoLogin(url?: string) {

    setTimeout(() => {
      if (/^https?:\/\//g.test(url!)) {
        this.document.location.href = url as string;
      } else {
        //this.router.navigateByUrl(url);
        this.document.location.href = url as string;
      }
    });
  }

  private checkJWT(model: any, offset?: number): boolean {
    return !!model?.token;
  }

  private process(): boolean {
    const res = this.checkJWT(this.token.get<any>(), 1000);
    if (!res) {
      var path = window.location.pathname;
      this.gotoLogin(this.LOGIN_URL + '?next=' + path);
    }
    return res;
  }

  // lazy loading
  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return this.process();
  }
  // route
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.process();
  }
  // all children route
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.process();
  }
}
